import { KeyRound, Pause, Play, Trophy, Volume2, VolumeX } from "lucide-react";
import { formatTime } from "../lib/api";
import { useT } from "../i18n";
import { LEVELS } from "../game/maze";

const Stat = ({ label, value, testId, danger }) => (
  <div className="hud-stat">
    <span className="hud-label">{label}</span>
    <span className={`hud-value${danger ? " danger" : ""}`} data-testid={testId}>{value}</span>
  </div>
);

export const Hud = ({ stats, paused, canPause, onPause, onBoard, muted, onMute, level }) => {
  const t = useT();
  const left = stats.left ?? LEVELS[level].time;
  return (
  <div className="hud" data-testid="game-hud">
    <div className="hud-title" data-testid="game-title">{t.hudTitle}</div>
    <div className="hud-stats">
      <Stat label={t.level} value={t.levels[level]} testId="hud-level" />
      <Stat label={t.timeLeft} value={formatTime(left)} testId="hud-timer" danger={left < 30000} />
      <Stat label={t.room} value="???" testId="hud-room" />
      {stats.hasKey && <Stat label={t.key} value={<KeyRound size={16} className="hud-key" />} testId="hud-key" />}
    </div>
    <div className="hud-actions">
      <button className="icon-btn" onClick={onMute} data-testid="hud-sound-button" aria-label={muted ? t.soundOn : t.soundOff}>
        {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
      </button>
      <button className="icon-btn" onClick={onPause} disabled={!canPause} data-testid="hud-pause-button" aria-label={t.pause}>
        {paused ? <Play size={16} /> : <Pause size={16} />}
      </button>
      <button className="icon-btn" onClick={onBoard} data-testid="leaderboard-button" aria-label={t.leaderboard}>
        <Trophy size={16} />
      </button>
    </div>
  </div>
  );
};
